import { css, CSSObject } from '@emotion/react'

export const wrapper = css({
  paddingTop: 15,
})

export const headerAssetOverrides: CSSObject = {
  height: 335,
  width: 632,
}

export const contentWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  padding: '15px 39px 0px 39px',
})

export const titleStyleOverrides = (readOnly: boolean): CSSObject => ({
  fontFamily: 'Helvetica',
  fontSize: 32,
  fontWeight: 700,
  letterSpacing: '-1px',
  lineHeight: '40px',
  maxHeight: 'none',
  padding: 0,

  '.tiptap': {
    padding: 2,
  },

  '&:hover': {
    backgroundColor: readOnly ? 'transparent' : undefined,
  },
})

export const accountSubtitleStyleOverrides = (
  readOnly: boolean
): CSSObject => ({
  fontFamily: 'Helvetica',
  lineHeight: '14px',
  maxHeight: 34,
  maxWidth: 448,
  minWidth: 448,

  '&:hover': {
    backgroundColor: readOnly ? 'transparent' : undefined,
  },
})

export const fauxButtonsWrapper = css({
  display: 'flex',
  gap: 8,
})

export const fauxButtonsIconWrapper = css({
  border: '1px solid black',
  borderRadius: '50%',
  display: 'flex',
  height: 32,
  justifyContent: 'center',
  width: 32,
})

export const contentDocumentWrapper = css({
  padding: '8px 27px 27px 27px',
})

export const documentStyleOverrides = (readOnly: boolean) =>
  css({
    '.CollaborationTextEditor': {
      border: 'none',
      borderRadius: 0,
      cursor: 'text',
      margin: 0,
      minHeight: 260,
      width: '100%',

      '&:hover': {
        backgroundColor: readOnly ? 'transparent' : '#F4F5F7',
      },
    },

    '.CollaborationTextEditorContent': {
      padding: 0,
    },

    '.CollaborationTextEditorControlBar': {
      borderRadius: 0,
      bottom: 0,
      justifyContent: 'center',
      position: 'sticky',
      width: '100%',
    },
  })
